import { Injectable } from '@angular/core';

@Injectable()
export class SelectedGenericIntegrationService {

	/**
	 * Generic function to generate the Menu items
	 *
	 * @param baseUrl
	 * @param mappers
	 * @param addOrganization
	 */
	getMenu(baseUrl: string, mappers: any[], addOrganization = true): any[] {
		const menu: any[] = [
			{
				route: `${baseUrl}/product-types`,
				label: 'Products',
				customIconClass: 'fas fa-cog'
			},
			{
				label: 'Mappers',
				customIconClass: 'fas fa-cog',
				items: []
			},
			{
				route: `${baseUrl}/status-messages`,
				label: 'Inbound Order Status',
				customIconClass: 'fas fa-cog',
				disabled: true
			},
			{
				route: `${baseUrl}/onhold-client-access`,
				label: 'On Hold Client Access',
				customIconClass: 'fas fa-cog',
				disabled: true
			},
			{
				route: `${baseUrl}/document-types`,
				label: 'Documents',
				customIconClass: 'fas fa-cog',
				disabled: true
			},
			{
				route: `${baseUrl}/form/default-settings`,
				label: 'Default Settings',
				customIconClass: 'fas fa-cog',
			},
			{
				route: `${baseUrl}/messages-to-ignore`,
				label: 'Outbound Messages',
				customIconClass: 'fas fa-cog',
				disabled: true
			},
			{
				route: `${baseUrl}/inbound-messages`,
				label: 'Inbound Messages',
				customIconClass: 'fas fa-cog',
				disabled: true
			},
			{
				route: `${baseUrl}/special/outgoing-events`,
				label: 'Outgoing Events',
				customIconClass: 'fas fa-cog',
				disabled: true
			},
		];

		const mappersMenu: any[] = [];
		mappers.forEach((menuItem: string) => {
			const item = {
				route: `${baseUrl}/mapper/${menuItem}`,
				label: menuItem
			};

			mappersMenu.push(item);
		});

		menu[1].items = mappersMenu;

		if (addOrganization) {
			menu.push({
				route: `${baseUrl}/organizations`,
				label: 'Organizations',
				customIconClass: 'fas fa-cog',
			});
		}

		return menu;
	}

}
